import { useCallback, useEffect, useState } from 'react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';

/** Same swipe/peek/dots/arrow treatment as the Explore programs carousel.
 *  Wrapped in data-no-swipe so SwipeNavigator doesn't read swipes as tab changes. */
export const StatsCarousel = ({ slides, testId = 'stats-carousel' }) => {
  const items = (slides || []).filter(Boolean);
  const [emblaApi, setEmblaApi] = useState(null);
  const [selected, setSelected] = useState(0);
  const [slideCount, setSlideCount] = useState(items.length);

  useEffect(() => {
    if (!emblaApi) return;
    const sync = () => {
      setSelected(emblaApi.selectedScrollSnap());
      setSlideCount(emblaApi.scrollSnapList().length);
    };
    sync();
    emblaApi.on('select', sync);
    emblaApi.on('reInit', sync);
    return () => {
      emblaApi.off('select', sync);
      emblaApi.off('reInit', sync);
    };
  }, [emblaApi]);

  const scrollToSlide = useCallback((index) => emblaApi?.scrollTo(index), [emblaApi]);

  if (!items.length) return null;

  return (
    <div data-no-swipe data-testid={testId}>
      <Carousel opts={{ align: 'start', loop: false, containScroll: 'trimSnaps' }} setApi={setEmblaApi}>
        <CarouselContent className="-ml-3 items-stretch">
          {items.map((slide) => (
            <CarouselItem key={slide.key} className="pl-3 basis-[88%]" data-testid={`${testId}-slide-${slide.key}`}>
              {slide.node}
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious
          className="hidden md:flex left-1 h-11 w-11 bg-[#141414]/90 border-accent/40 text-accent hover:bg-accent hover:text-accent-foreground"
          data-testid={`${testId}-prev`}
        />
        <CarouselNext
          className="hidden md:flex right-1 h-11 w-11 bg-[#141414]/90 border-accent/40 text-accent hover:bg-accent hover:text-accent-foreground"
          data-testid={`${testId}-next`}
        />
      </Carousel>

      <div className="mt-3 flex items-center justify-center gap-2" data-testid={`${testId}-dots`}>
        {Array.from({ length: slideCount }).map((_, i) => (
          <button
            key={i}
            type="button"
            onClick={() => scrollToSlide(i)}
            aria-label={`Go to card ${i + 1}`}
            className={`h-1.5 rounded-full transition-all ${i === selected ? 'w-6 bg-accent' : 'w-1.5 bg-white/25'}`}
            data-testid={`${testId}-dot-${i}`}
          />
        ))}
      </div>
    </div>
  );
};

export default StatsCarousel;
